// translations/pages/team/en.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageEN = {
  hero: {
    title: 'Team',
    intro: 'Adrian Eisenmeier and Nikolai Genov founded pAIoneer Labs GmbH and run it as managing directors.',
    members: 'Adrian Eisenmeier is a diploma physicist and builds systems where AI, software architecture, data protection and security meet. Nikolai Genov holds a PhD in bioinformatics and is technical lead for AI-assisted software development and analytics in regulated healthcare, life sciences and finance. Alina Tselinina is a software developer and data engineer with a master\'s degree in financial and actuarial mathematics and builds applications, REST APIs and data pipelines in Python and R.'
  },
  card: {
    cta: 'View profile'
  },
  profile: {
    overview: 'Team',
    membersLabel: 'Team members'
  }
};
